<script lang='ts'>
import type { InternalRuleItem, RuleItem, Rules, Value } from 'async-validator'
import type { PropType } from 'vue'
import * as R from 'ramda'
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'MsSearchForm',
  props: {
    modelValue: {
      required: true,
      type: Object,
    },
    banZeroProps: {
      type: Array as PropType<string[]>,
      default: () => ['id'],
    },
    notResetProps: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    disabledResetSearch: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'search', 'reset'],
  setup(props, ctx) {
    const formRef = ref()
    const rules = ref<Rules>({})

    const banZeroRule: RuleItem = {
      validator: (rule: InternalRuleItem, value: Value, callback: (error?: string | Error) => void) => {
        let errorMessage
        if (Number.parseInt(value) === 0) {
          errorMessage = '错误ID'
        }
        if (errorMessage) {
          callback(errorMessage)
        } else {
          callback()
        }
      },
    }

    const initRules = () => {
      rules.value = {}
      props.banZeroProps.forEach((p) => {
        rules.value[p] = banZeroRule
      })
    }
    initRules()
    watch(() => props.banZeroProps, initRules)

    function search() {
      formRef.value.validate(async (valid: boolean) => {
        if (!valid) {
          return
        }
        ctx.emit('search')
      })
    }

    function resetValue() {
      const resetObject = R.pick(props.notResetProps, props.modelValue)
      ctx.emit('update:modelValue', resetObject)
    }

    function reset() {
      resetValue()
      ctx.emit('reset')
      !props.disabledResetSearch && search()
    }

    function resetFields() {
      formRef.value.resetFields()
      formRef.value.clearValidate()
    }

    return {
      formRef,
      rules,
      search,
      reset,
      resetValue,
      resetFields,
    }
  },
})
</script>

<template>
  <div class="card-container search-bar-container">
    <el-form
      ref="formRef" :rules="rules" :inline="true" :model="modelValue"
      @keyup.enter="search" @submit.prevent
    >
      <slot />
      <el-form-item class="button-wrap">
        <el-button type="primary" @click="search">
          查询
        </el-button>
        <el-button @click="reset">
          重置
        </el-button>
      </el-form-item>
      <!-- 后置元素 -->
      <slot name="append" />
    </el-form>
  </div>
</template>

<style lang='scss' scoped>
.search-bar-container {
  padding: $space-sm $space-md 0;
  overflow: hidden;

  ::v-deep(.el-form--inline .el-form-item) {
    margin-right: $space-sm;
    margin-bottom: $space-sm;

    &.is-error {
      margin-bottom: 24px;
    }
  }

  .button-wrap {
    margin-right: $space-md;
  }

  .el-button + .el-button {
    margin-left: $space-sm;
  }
}
</style>
